goog.module('yext.storm.fields');
goog.module.declareLegacyNamespace();

/**
 * @param {!HTMLElement} el
 */
function clearIndeterminate(el) {
  // Handles a generic (full field is indeterminate)
  $(el.form).find('[name="' + el.name + 'IsIndeterminate"], [name="' + el.name + 'Indeterminate"]').remove();

  // Support the case where if a field has many fields that can be indeterminate
  // e.g. Each field has a hidden input [fieldname].indeterminate that gets removed as soon as something is changed.
  // It also supports replacing <Various Content> placeholders with their original value, as long as you add
  // a data-placeholder="original value" attribute to the input
  var $field = $(el);
  var n = $field.attr('name');
  var $indeterminate = $field.closest('.field-wrap,.text-field').find('[name="'+n+'.indeterminate"]');

  $field.attr('placeholder', $field.data('placeholder') || '');
  if ($indeterminate && $indeterminate.length > 0) {
    $indeterminate.remove();
  }
}
goog.exportSymbol('clearIndeterminate', clearIndeterminate);

exports = {
  clearIndeterminate,
};
